<template>
  <div>
    <el-row style="color: #F56C6C; font-size: 20px; font-weight: bolder;margin-top:20px;">
      <el-col :xl="3" :lg="5" :md="6">
        <span>
          日期：{{ orderDate }}
        </span>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px;">
      <el-col style="margin-top: 20px;">
        <el-form :inline="true" class="demo-form-inline" :model="searchForm" ref="searchForm" @submit.native.prevent>
          <el-form-item label="产品名称：">
            <el-input size="medium" placeholder="产品名称" @keyup.enter.native="seachFun()" clearable @clear="initializeList" v-model="searchForm.name"
              :value="searchForm.name"></el-input>
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input size="medium" placeholder="产品编码" @keyup.enter.native="seachFun()" clearable @clear="initializeList" v-model="searchForm.code"
              :value="searchForm.code"></el-input>
          </el-form-item>
          <el-form-item label="品牌：">
            <el-input size="medium" placeholder="品牌" @keyup.enter.native="seachFun()" clearable @clear="initializeList" v-model="searchForm.brand"
              :value="searchForm.brand"></el-input>
          </el-form-item>
          <el-button size="medium" type="primary" @click="seachFun()">筛选</el-button>
        </el-form>
      </el-col>
    </el-row>
    <!-- 商品列表-表格形式 -->
    <el-row>
      <el-col :span="24">
        <el-table stripe border :data="mainList" style="width: 100%">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <!-- <el-table-column label="图片" prop="PIC_URL"  min-width="45">
              <template slot-scope="scope">
                <img :src="showImg(scope.row)" style="width: 80px; height: 80px" onerror="this.src='https://service.linkda.com.cn/productImg.jpg';this.onerror=null"/>
              </template>
            </el-table-column> -->
          <el-table-column label="编码" prop="PRODUCT_CODE" min-width="60"></el-table-column>
          <el-table-column label="名称" prop="PRODUCT_NAME" min-width="130"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT" min-width="60"></el-table-column>
          <el-table-column label="单价" prop="PRICE" min-width="60"></el-table-column>
          <el-table-column label="购买数量" prop="product_count" min-width="60">
            <template slot-scope="scope">
              <el-input v-model="scope.row.product_count" @keyup.enter.native="addShopCar(scope.row)" :disabled="setBtnStatus(scope.row, true, false)"
                clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="100">
            <template slot-scope="scope">
              <el-button size="small" :type="setBtnStatus(scope.row, 'danger', '')" @click="addShopCar(scope.row)">
                {{ setBtnStatus(scope.row, '取消', '购买') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!--进界面的弹框-->
    <el-dialog title="请选择" :visible.sync="isAddBtnToProduct" width="30%" :show-close="false" :close-on-click-modal="false">
      <el-form :ref="firstForm" :model="firstForm" label-width="100px" style="text-align: inherit;margin: 0">
        <el-form-item label="送货日期：">
          <el-date-picker v-model="firstForm.date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 100%"
            :clearable="false"></el-date-picker>
        </el-form-item>
        <el-form-item label="应急供应商：">
          <el-select v-model="firstForm.supplier" filterable placeholder="请选择供应商" clearable style="width: 100%" @change="queryFirstTC">
            <el-option v-for="item in supplierList" :key="item.VENDOR_ID" :label="item.AB_NAME" :value="item.VENDOR_ID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" style="margin-right: 13px" @click="cancel()">取消</el-button>
        <el-button size="small" @click="isfirstSure()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  queryDateFun, submitOrderDate, addShoppingCart, deleteProduct, emergencySupplier, getEmergencyFun,
} from '@/assets/api/purchaseOrderManage';
import http from '@/assets/common/http';
import util from '@/assets/common/util';

export default {
  data() {
    return {
      BE_PRICE: Number(sessionStorage.getItem('BE_PRICE')),
      mainList: [],
      statusList: [],
      defaultImg: 'https://service.linkda.com.cn/mjd-logo1.jpg',
      searchForm: {},
      firstForm: {
        date: '',
      },
      pickerOptions1: {
        // disabledDate(time) {
        //   return time.getTime() < Date.now();//如果没有后面的-8.64e7就是不可以选择今天的
        // }
      },
      orderDate: '',
      car_id: '',
      supplierList: [],
    };
  },
  created() {
    // this.queryDate()
    this.querySupplier();
  },
  computed: {
    isAddBtnToProduct() {
      return this.$store.getters.isAddBtnToProduct;
    },
  },
  methods: {
    initializeList() {
      this.queryDate();
    },
    // 查看是否存在送货日期
    queryDate() {
      queryDateFun()
        .then((result) => {
          if (result.length !== 0) {
            this.$store.commit('SET_ADD_BTN_TO_PROJECT', false);
            this.orderDate = result[0].ORDER_DATE;
            this.car_id = result[0].ID;
          } else {
            this.$store.commit('SET_ADD_BTN_TO_PROJECT', true);
            this.orderDate = '';
            this.car_id = 0;
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 提交下单时间
    isfirstSure() {
      // 关账限制
      if (this.$util.isOrderClosed(this.firstForm.date)) {
        this.$message.show({ text: '该月份已关账，无法下单', type: 'warning' });
        return false;
      }

      this.$store.commit('SET_ADD_BTN_TO_PROJECT', false);
      this.orderDate = this.firstForm.date;
      // 先检测属性是否都正确
      const params = {
        ORDER_DATE: this.firstForm.date,
      };
      submitOrderDate(params)
        .then((result) => {
          this.queryDate();
          this.$store.commit('SET_ADD_BTN_TO_PROJECT', false);
          this.car_id = result[0].ID;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    //  点击筛选按钮触发
    seachFun() {
      const params = {
        ORDER_DATE: this.orderDate,
        VENDOR_ID: this.firstForm.supplier,
      };
      if (this.searchForm.name) {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      if (this.searchForm.code) {
        params.PRODUCT_CODE = this.searchForm.code;
      }
      if (this.searchForm.brand) {
        params.PRODUCT_NAME = this.searchForm.brand;
      }
      getEmergencyFun(params).then((result) => {
        if (result.length !== 0) {
          this.mainList = result.map((item) => Object.assign(item, { PRODUCT_CODE: item.PRODUCT_CODE.toString() }));
        } else {
          this.mainList = [];
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    filterStatusList(status) {
      return this.statusList.filter((item) => item.ID === status.ID);
    },
    // -------------加入购物车
    async addShopCar(row) {
      const statusItem = {
        PRODUCT_CODE: row.PRODUCT_CODE, product_count: Number(row.product_count), VENDOR_ID: row.VENDOR_ID, ID: row.ID,
      };
      if (!util.JudgmentUnit(row.TYPE_UNIT)) { // 如果不是
        const beInter = (row.product_count % 1 === 0);
        if (beInter == false) {
          this.$message.show({ text: '单位不是公斤的，只能输入整数', type: 'error' });
          return false;
        }
      }
      if (row.product_count !== undefined) {
        const product = this.filterStatusList(statusItem);
        if (product.length === 0) {
          // 添加购物车成功
          const params1 = {
            SERVICE_ID: '15066',
            OTYPE: 13,
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            SUPPLIER_ID: this.firstForm.supplier,
            PRODUCT_CODE: row.PRODUCT_CODE,
          };
          let TAX_RATE = 0; let flag = false;
          await http.post(params1).then((res) => {
            TAX_RATE = res[0].TAX_RATE;
          }).catch((err) => {
            this.$message.show({ text: err, type: 'error' });
            flag = true;
          });
          if (flag) {
            return false;
          }
          const params2 = {
            CART_ID: Number(this.car_id),
            VENDOR_ID: row.VENDOR_ID,
            PRODUCT_CODE: row.PRODUCT_CODE,
            PRICE: Number(row.PRICE),
            PRODUCT_COUNT: Number(row.product_count),
            TAX_RATE,
            BEFORE_TAX_PRICE: Math.round((Number(row.PRICE) / (1 + TAX_RATE / 100)) * 100) / 100,
          };
          addShoppingCart(params2).then((res) => {
            this.statusList.push(statusItem);
          }).catch((err) => {
            this.$message.show({ text: err, type: 'error' });
          });
        } else {
          this.removeIndexToArr(this.statusList, ...product);
          this.removeProductFromServer(...product);
        }
      } else {

      }
    },

    // 从服务器上删除添加购物车的产品
    removeProductFromServer(product) {
      const params = {
        PRODUCT_CODE: product.PRODUCT_CODE,
      };
      deleteProduct(params)
        .then((res) => {
        }).catch((err) => {
          this.$message.show({ text: err, type: 'error' });
        });
    },
    // remove数组特定列的函数
    removeIndexToArr(arr, snapArr) {
      arr.forEach((product, index) => {
        if (product.PRODUCT_CODE === snapArr.PRODUCT_CODE && product.VENDOR_ID === snapArr.VENDOR_ID) {
          arr.splice(index, 1);
        }
      });
    },
    /**
     * @param index: 唯一索引值
     * @param clickStatus：点击后的显示状态
     * @param normalStatus 正常的显示状态
     */
    setBtnStatus(row, clickStatus, normalStatus) {
      const product = this.filterStatusList(row);
      if (product.length !== 0) {
        this.mainList.forEach((item) => {
          // if (item.PRODUCT_CODE === product[0].PRODUCT_CODE && row.VENDOR_ID === product[0].VENDOR_ID) {
          if (item.ID === product[0].ID) {
            item.product_count = product[0].product_count;
          }
        });
        return clickStatus;
      }
      return normalStatus;
    },

    // 首页模态框点击取消触发
    cancel() {
      this.$router.back();
    },
    querySupplier() {
      const params = {};
      emergencySupplier(params)
        .then((res) => {
          this.supplierList = res;
        }).catch((err) => {
          this.$message.show({ text: err, type: 'error' });
        });
    },
    queryFirstTC(e) {
      this.firstForm.SUPPLIER_ID = e;
    },
  },
  beforeDestroy() {
    this.$store.commit('SET_ADD_BTN_TO_PROJECT', true);
    sessionStorage.setItem('CAR_ID', this.car_id);
  },
};
</script>
<style scoped>
.clearfix span {
  font-size: 18px;
  margin-left: 10px;
}

.box-card {
  width: 355px;
  height: 200px;
  display: flex;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin-left: 15px;
}

@media screen and (max-width: 1025px) {
  .box-card {
    width: 45%;
    display: flex;
  }
}

.card-image {
  width: 140px;
  height: 140px;
  margin: auto 0;
  border-radius: 5px;
}

.card-image img {
  width: 90%;
  margin: 0 5%;
  height: 110px;
}

.card-info {
  height: 170px;
  font-size: 15px;
  padding-top: 30px;
}

.r_main {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.name,
.btn,
.supplier_name {
  margin-top: 10px;
}

.detail {
  margin-top: -5px;
}

.supplier_name {
  width: 220px;
  height: 20px;
  line-height: 20px;
}

.name {
  width: 210px;
  height: 30px;
  line-height: 30px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-weight: bold;
  /* 换行 */
  white-space: nowrap;
  /* 显示点点点 */
  text-overflow: ellipsis;
}

.null_data {
  position: absolute;
  left: 45%;
  top: 20px;
  transform: translate(-50%);
  color: #888;
}

.el-table .cell {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/shopOrderManage/emergencyOrder.vue